<template>
  <span class="icon" :class="classes">
    <component :is="icons[icon].name" class="icon__svg" />
    <slot />
  </span>
</template>

<script>
  //https://vue-feather-icons.netlify.com/
  //import * as icons from 'vue-feather-icons';
  import * as icons from '@zhuowenli/vue-feather-icons'

  export default {
    name: "Icon",
    components: {
      ...icons,
    },
    props: {
      icon: !String,
      spinning: Boolean,
      hidden: Boolean,
    },
    data() {
      return {
        classes: {
          spinning: this.spinning,
          hidden: this.hidden
        },
        icons,
      }
    },
    methods: {
      setHidden(isHidden) {
        this.classes.hidden = isHidden;
      }
    },
  }
</script>
